// Swiper-based replacement for the old owl.carousel.js carousel (dropped so this section no
// longer needs jQuery + owl.carousel.min.js + owl CSS). Swiper itself is loaded lazily, on
// demand, via the same window.ShopLCSwiperAssets loader header-drawer.js already uses.
//
// Kept: the MutationObserver + polling fallback from the original. The `.owl-carousel` markup
// this targets is authored content (rich text / app blocks) that can render after this script
// runs, so we still need to wait for it to show up - only the init logic (owl -> Swiper) changed.
(function () {
  var blogPostCarouselObserverStarted = false;

  function ensureSwiperLoaded() {
    if (typeof window.Swiper !== 'undefined') return Promise.resolve();
    if (window.__shoplcSwiperLoading) return window.__shoplcSwiperLoading;

    var assets = window.ShopLCSwiperAssets || {};

    if (assets.css && !document.querySelector('link[href="' + assets.css + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = assets.css;
      document.head.appendChild(link);
    }

    window.__shoplcSwiperLoading = new Promise(function (resolve) {
      if (!assets.js) {
        resolve();
        return;
      }

      var existingScript = document.querySelector('script[src="' + assets.js + '"]');
      if (existingScript) {
        existingScript.addEventListener('load', function () { resolve(); }, { once: true });
        existingScript.addEventListener('error', function () { resolve(); }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = assets.js;
      script.addEventListener('load', function () { resolve(); });
      script.addEventListener('error', function () { resolve(); });
      document.head.appendChild(script);
    });

    return window.__shoplcSwiperLoading;
  }

  // owl.carousel used to treat every direct child as an item automatically. Swiper needs an
  // explicit .swiper-wrapper > .swiper-slide structure, so build it from whatever markup is
  // already inside the .owl-carousel container - no content edit required.
  function wrapForSwiper(root) {
    var existing = root.querySelector(':scope > .swiper-wrapper');
    if (existing) return existing;

    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    Array.prototype.slice.call(root.children).forEach(function (child) {
      child.classList.add('swiper-slide');
      wrapper.appendChild(child);
    });

    root.classList.add('swiper');
    root.appendChild(wrapper);

    var prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    var nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    root.appendChild(prevBtn);
    root.appendChild(nextBtn);

    return wrapper;
  }

  function initBlogPostCarousel(root) {
    if (root.dataset.swiperInited === '1') return true;

    var wrapper = wrapForSwiper(root);
    var slideCount = wrapper.querySelectorAll(':scope > .swiper-slide').length;
    if (slideCount === 0) return true;

    root.dataset.swiperInited = '1';

    if (slideCount === 1) {
      root.classList.add('swiper--static');
      return true;
    }

    ensureSwiperLoaded().then(function () {
      if (typeof window.Swiper === 'undefined') return;

      new window.Swiper(root, {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 1,
        autoplay: { delay: 3000, disableOnInteraction: false },
        navigation: {
          nextEl: root.querySelector('.swiper-button-next'),
          prevEl: root.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: { slidesPerView: 3 },
        },
      });
    });

    return true;
  }

  function initBlogPostCarousels() {
    var carouselWrapper = document.querySelector('.blog-post');
    if (!carouselWrapper) return true;

    var carousels = carouselWrapper.querySelectorAll('.owl-carousel');
    if (!carousels.length) return true;

    var initialized = true;
    carousels.forEach(function (el) {
      if (!initBlogPostCarousel(el)) initialized = false;
    });

    return initialized;
  }

  function observeBlogPostCarousels() {
    var carouselWrapper = document.querySelector('.blog-post');

    if (!carouselWrapper || !carouselWrapper.querySelector('.owl-carousel')) return;

    if (initBlogPostCarousels()) return;
    if (blogPostCarouselObserverStarted) return;

    blogPostCarouselObserverStarted = true;

    var fallbackInterval = null;
    var observer = new MutationObserver(function () {
      if (initBlogPostCarousels()) {
        if (fallbackInterval) {
          window.clearInterval(fallbackInterval);
        }

        blogPostCarouselObserverStarted = false;
        observer.disconnect();
      }
    });

    observer.observe(carouselWrapper, {
      childList: true,
      subtree: true,
    });

    var attempts = 0;
    fallbackInterval = window.setInterval(function () {
      attempts += 1;

      if (initBlogPostCarousels() || attempts >= 10) {
        window.clearInterval(fallbackInterval);
        blogPostCarouselObserverStarted = false;
        observer.disconnect();
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBlogPostCarousels);
  } else {
    observeBlogPostCarousels();
  }

  window.addEventListener('load', observeBlogPostCarousels);
  document.addEventListener('shopify:section:load', observeBlogPostCarousels);
})();
